import * as React from "react";
import { useField } from 'informedv4';
import * as classnames from 'classnames';
import '../components/Switch.css';
import { replaceDotsWithHyphens } from "../../misc/Helpers/StringHelper";

interface CheckboxProps {
    id: string;
    field: string;
    name?: string;
    label: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    onChange?: (boolean) => void;
    automationId?: string;
    labelSuffix?: () => React.JSX.Element
}

export const Checkbox = ({ id, name, field, label, disabled, required, onChange, automationId = null, labelSuffix = null }: CheckboxProps) => {
    const { fieldState, fieldApi } = useField({ name: name });
    const { setValue } = fieldApi;

    const togglerClasses = classnames(
        'switch-toggle',
        `switch-toggle--${fieldState.value ? 'on' : 'off'}`
    )

    return (
        <>
            <div className="switch switch--small" aria-disabled={disabled} onClick={() => {
                if (disabled)
                    return;

                if (onChange !== null && onChange !== undefined)
                    onChange(!fieldState.value);

                setValue(!fieldState.value);
            }}>
                <div id={id} className={togglerClasses} data-automationid={automationId ?? replaceDotsWithHyphens(field)}></div>
                <label>{label}
                    {labelSuffix ? labelSuffix() : null}
                </label>
            </div>
        </>
    );
}
